import React from 'react'

const PromoContent = ({containerObject}) => {
  return (
    <>
     <p>PromoContent</p>
     {containerObject && containerObject.targeterResult ? <div dangerouslySetInnerHTML={{ __html: containerObject.targeterResult }}  ></div> : ""}</>
  )
}

export default PromoContent